<div class="ir-plugin th-plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ 'common.add' | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.photos-suggestions.name' | translate }} <strong></strong
      ></span>
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data">
          <div *ngFor="let message of messages">
            <span innerHtml="{{ message | translate: { value: plugin } }}"></span>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span>{{ 'plugins.photos-suggestions.take-picture-to-illustrate' | translate }}</span>
    </p>
    <div *ngIf="assets && assets.length > 0">
      <div class="ir-line ir-plugin-photo th-plugin-photo" *ngFor="let asset of assets">
        <div class="ir-line--right">
          <div
            class="ir-btn th-btn-normal"
            [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
            [routerLink]="getSuggestionEditRoute(asset)"
          >
            <span>{{ 'plugins.photos-suggestions.suggestion' | translate }}</span>
          </div>
          <div
            class="ir-btn th-btn-normal"
            [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
            [routerLink]="getEditAssetRoute(asset)"
          >
            <span>{{ 'plugins.photos-suggestions.comment' | translate }}</span>
          </div>
        </div>
        <div class="ir-line--left" *ngIf="asset && asset.suggestedAsset">
          <div class="ir-plugin-area--photo">
            <img src="/api/assets/{{ suggestedAsset }}/content/thumb" alt="" />
          </div>
        </div>
        <div class="ir-line--left" *ngIf="asset">
          <div class="ir-plugin-area--photo">
            <img *ngIf="getImageUrl(asset.id) && !asset.svg" #image [src]="getImageUrl(asset.id)" alt="" />
            <div [innerHtml]="getSvg(asset.svg, asset.id)" *ngIf="asset.svg" class="edit-svg"></div>
          </div>
        </div>
        <div class="ir-row">
          <div class="ir-line-content-flow">
            <span innerHtml="{{ asset.comment }}"></span>
          </div>
          <div class="ir-line-content-flow" *ngIf="asset.type > 0">
            <span>
              {{ 'plugins.add-photos.to' | translate }}<strong> {{ asset.type | fileAndSuggestionToType }}</strong>
            </span>
          </div>
          <div class="ir-line-content-flow" *ngIf="asset.annotationComments">
            <span>
              <strong
                >{{ 'plugins.add-photos.annotation-id' | translate }}
                {{ 'plugins.add-photos.annotation-description' | translate }}</strong
              >
            </span>
            <div *ngFor="let annotationComment of asset.annotationComments | keyvalue">
              <span>{{ annotationComment.key }} {{ annotationComment.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
